module.exports = __webpack_public_path__ + "right.s_8sMY7m.svg";